import { Component } from '@angular/core';

@Component({
  selector: 'empathy-rating-description',
  templateUrl: 'rating-description.component.html',
  styleUrls: ['./rating-description.component.scss']
})
export class RatingDescriptionComponent {}
